<template>
  <md-toolbar
    class="md-transparent bring-back"
    :class="{'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute}"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start" style="margin-left:10px;">
        <a href="#/">
          <div class="logo-image"></div>
          <!-- <img class="logo-image" :src="this.$store.state.branding.logoUrl" /> -->
        </a>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{toggled: $sidebar.showSidebar}"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="free-text-search">
            <md-field>
              <label>Search...</label>
              <md-input v-model="searchString" v-on:keyup.enter="openSearch"></md-input>
              <md-button class="md-just-icon md-round" v-on:click="openSearch">
                <md-icon>search</md-icon>
              </md-button>
              <md-button
                class="md-just-icon md-round"
                title="Search from reference list"
                v-on:click="showModalare"
              >
                <md-icon>add_box</md-icon>
              </md-button>
            </md-field>
          </div>
          <md-list>
            <md-list-item to="/content" title="View content">
              <i class="material-icons pz-navbar-icon">apps</i>
              <p class="hidden-lg hidden-md">Content</p>
            </md-list-item>

            <li class="md-list-item">
              <a
                v-on:click.stop
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content" title="View recent downloads">
                  <drop-down direction="down" multiLevel>
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      v-on:click="resetNewDownloads()"
                      data-toggle="dropdown"
                    >
                      <i class="material-icons pz-navbar-icon">cloud_download</i>
                      <span
                        v-if="this.$store.state.newDownloads.length > 0"
                        class="notification pz-navbar-background"
                      >{{this.$store.state.newDownloads.length}}</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>

                    <ul class="dropdown-menu dropdown-menu-right">
                      <li class="user-menu-item" v-if="this.$store.state.pregeneratedCarts.length != 0">
                      <a
                        class="dropdown-toggle user-item"
                        :class="{'open': multiLevel}"
                        @click="toggleMultiLevel"
                      >
                        <span>Pregenerated packages</span>
                      </a>

                      <ul class="dropdown-menu">
                        <li class="language-header">Download pregenerated package</li>
                        <li
                          v-for="(cart, index) in this.$store.state.pregeneratedCarts"
                          :key="index"
                        >
                        <a
                          class="topnavbar-pz-link"
                          :href="cart.url"
                        >
                          <md-icon>archive</md-icon>
                          {{cart.name}}
                        </a>
                        </li>
                      </ul>
                    </li>

                      <li
                        v-if="(this.$store.state.downloads.length + this.$store.state.downloading.length) == 0"
                      >
                        <a class="topnavbar-pz-link-empty" href="#">No downloads available</a>
                      </li>
                      <li
                        v-for="(download, index) in this.$store.state.downloading"
                        :key="index  + '-downloading'"
                      >
                        <a v-on:click.stop class="topnavbar-pz-link-empty">
                          <dot-loader size="20"></dot-loader>
                          <span>{{download.name}}</span>
                          <span v-if="download.progress">{{download.progress}}%</span>
                        </a>
                      </li>
                      <li
                        v-for="(download, index) in this.$store.state.downloads.slice(0,5)"
                        :key="index  + '-download'"
                      >
                        <a
                          class="topnavbar-pz-link"
                          v-bind:class="{ newDowload: isNewDownload(download) }"
                          :href="download.url"
                        >
                          <md-icon>archive</md-icon>
                          {{download.name}}
                        </a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <li class="md-list-item">
              <a
                v-on:click="openCart()"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                      title="View cart"
                    >
                      <i class="material-icons pz-navbar-icon">shopping_cart</i>
                      <span class="notification pz-background">{{this.$store.state.cart.length}}</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                  </drop-down>
                </div>
              </a>
            </li>
            <li class="md-list-item" v-if="this.$store.state.environments.length > 0">
              <a class="md-list-item-router md-list-item-container md-button-clean dropdown">
                <div class="md-list-item-content" title="Change environment">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <i class="material-icons pz-navbar-icon">settings</i>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li
                        v-for="(environment, index) in this.$store.state.environments"
                        :key="index  + '-environment'"
                      >
                        <a
                          class="topnavbar-pz-link"
                          v-on:click="confirmChangeEnvironment(environment.id)"
                        >
                          <md-icon>home</md-icon>
                          {{environment.name}}
                        </a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
            <!--
            <li class="md-list-item">
              <a
                href="#/environment/settings"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      title="Environment Settings"
                    >
                      <i class="material-icons pz-navbar-icon">settings</i>
                    </md-button>
                </div>
              </a>
            </li>
            -->
            <li class="md-list-item">
              <div class="md-list-item-content">
                <drop-down direction="down" multiLevel>
                  <md-button
                    slot="title"
                    class="md-sm md-simple dropdown-toggle md-block md-just-icon"
                    data-toggle="dropdown"
                  >
                    <i class="md-icon md-icon-font pz-navbar-icon">face</i>
                    <span class="user-name">{{this.$store.state.user.name}}</span>
                  </md-button>
                  <ul class="dropdown-menu">
                    <!-- if user has more than one site

Changing site should reload the page and clear the cart... => Downloads per site

 <li class="user-menu-item">

                    </li>
                    -->
                    <li class="user-menu-item">
                      <a
                        class="dropdown-toggle user-item"
                        :class="{'open': multiLevel}"
                        @click="toggleMultiLevel"
                      >
                        <md-icon>language</md-icon>
                        <span>{{this.$store.state.user.languageName}}</span>
                      </a>

                      <ul class="dropdown-menu">
                        <li class="language-header">View product info in</li>
                        <li
                          v-for="(language, index) in languages"
                          :key="index"
                        >
                          <a v-on:click="setActiveLanguage(language.key)" class="user-item">
                            <img style="height:11px" :src="'img/flags/' + language.key + '.png'" />
                            &nbsp; {{language.value}}
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li class="user-menu-item">
                      <a @click="logout" class="user-item">
                        <md-icon>power_settings_new</md-icon>
                        <span>Logout</span>
                      </a>
                    </li>
                  </ul>
                </drop-down>
              </div>
            </li>
          </md-list>
        </div>
      </div>
    </div>
    <modal v-if="showModal" @close="modalHide">
      <template slot="header">
        <h4 class="modal-title">Search for list of references</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <textarea
          v-model="searchList"
          class="multi-input"
          placeholder="Paste reference numbers list here"
        ></textarea>

        <div class="cart-button">
          <md-button class="md-sm clear-content" @click="clearList">Clear</md-button>

          <md-button class="md-sm open-result" v-on:click="openList">Search</md-button>
        </div>
      </template>
    </modal>
     <modal v-if="changeEnvironmentConfirmationModal" @close="changeEnvironmentConfirmationModal = false" class="confirmChangeEnvironment">
      <template slot="header">
        <h4 class="modal-title">Cart not empty</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="changeEnvironmentConfirmationModal = false"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <p>Changing environment will clear the cart.</p>
        <p>Do you wish to continue?</p>

      </template>

      <template slot="footer">
         <md-button
          class="md-sm cancel-change-environment add-to-cart"
          @click="changeEnvironmentConfirmationModal = false"
        >Cancel</md-button>
        <md-button
          class="md-sm add-to-cart"
          @click="setActiveEnvironment"
        >Continue</md-button>
      </template>
    </modal>
  </md-toolbar>
</template>

<script>
import { DotLoader, Modal } from "@/components";
import $ from "jquery";
import UserService from "@/services/UserService";
import CartService from "@/services/CartService";

export default {
  components: {
    DotLoader,
    Modal
  },
  data() {
    return {
      selectedEmployee: "",
      multiLevel: false,
      showModal: false,
      timer: "",
      changeEnvironmentConfirmationModal: false,
      selectedEnvironment: ""
    };
  },
  created: function() {
    this.getOngoingDownloads();
    this.timer = setInterval(this.checkOngoingDownloads, 2000); // how often should we check?
  },
  computed: {
    searchString: {
      get: function() {
        return this.$store.state.searchString;
      },
      set: function(newValue) {
        this.$store.commit("setSearchString", newValue);
      }
    },
    searchList: {
      get: function() {
        return this.$store.state.searchList;
      },
      set: function(newValue) {
        this.$store.commit("setSearchList", newValue);
      }
    },
    languages: function () {
      return this.$store.state.user.languages;
    }
  },
  methods: {
    confirmChangeEnvironment(environment) {

      this.selectedEnvironment = environment;
      if (this.$store.state.cart.length > 0) {
        this.changeEnvironmentConfirmationModal = true;
      } else {
        this.setActiveEnvironment();
      }
    },
    async setActiveEnvironment() {
      await UserService.SetUserEnvironment(this.selectedEnvironment);

      this.$store.commit("clearCart");
      this.$store.commit("clearFilters");
      this.$store.commit("setSearchString", "");
      this.$store.commit("setSearchList", "");
      this.$store.commit("setSearchSinceUtc", null);

      location.reload();
    },
    async checkOngoingDownloads() {
      if (
        this.$store.state.downloading == null ||
        this.$store.state.downloading.length == 0
      ) {
        return;
      }
      var self = this;
      var store = this.$store;
      console.log(this.$store.state.downloading);
      this.$store.state.downloading.forEach(function(downloading) {
        //  this.checkDownloadStatus(downloading);
        CartService.GetCartDownloadStatus(downloading.id).then(function(
          response
        ) {

           if (response.data.result.key == "Error") {
             store.commit("removeFromDownloading", { name: downloading.name });
            return;
          }

          if (response.data.result.key != "Complete") {
            downloading.progress = parseInt(response.data.result.value);
            return;
          }

          store.commit("removeFromDownloading", downloading);
          let notification = self.$notifications.state.find(obj => obj.download && obj.download.id === downloading.id);
          self.$notifications.removeNotification(notification.timestamp);

          store.commit("addDownload", {
            name: downloading.name,
            url: response.data.result.value
          });

          store.commit("addNewDownload", {
            name: downloading.name,
            url: response.data.result.value
          });

          self.$notify({
            message: "Package successfully created",
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "pz",
            timeout: 10000
          });
        });
      });
    },
    cancelAutoUpdate: function() {
      clearInterval(this.timer);
    },
    async getOngoingDownloads() {
      await CartService.GetOngoingDownloads().then(response =>
        this.$store.commit("addMultipleDownloading", response.data.result)
      );

      //this.$store.commit("addMultipleDownloading", response.data).then(result => this.$store.commit("setUser", result.data.result));
    },
    async setActiveLanguage(language) {
      const response = await UserService.UpdateUserLanguage(language, this.$store.state.activeEnvironment.id);
      //this.$store.commit("setUser", response.data.result);
      location.reload();
      // await UserService.UpdateUserLanguage(language)
      //   .then(result => this.$store.commit("setUser", result.data.result))
      //   .then(location.reload());
    },
    async openList() {
      this.$store.commit("clearFilters");
      this.$store.commit("setSearchString", "");
      this.$store.commit("setSearchSinceUtc", null);
      this.modalHide();
      if (this.$route.path == "/content") {
        this.$store.commit("setSearchAction", true);
      } else {
        this.$router.push({ name: 'content'});
      }
    },
    async clearList() {
      // this.$store.commit("clearFilters");
      // this.$store.commit("setSearchString", "");
      // this.modalHide();
      this.searchList = "";
      if (this.$route.path == "/content") {
        this.$store.commit("setSearchAction", true);
      }
    },
    async openSearch() {
      //  this.$store.commit("setSearchString", search);
      this.$store.commit("clearFilters");
      this.$store.commit("setSearchList", "");
      this.$store.commit("setSearchSinceUtc", null);
      if (this.$route.path == "/content") {
        this.$store.commit("setSearchAction", true);
      } else {
        this.$router.push({ name: 'content'});
      }
    },
    modalHide: function() {
      this.showModal = false;
      $("body").css("overflow", "auto");
    },
    showModalare() {
      this.showModal = true;
      $("body").css("overflow", "hidden");
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      window.location.href = window.logoutUrl;
      window.location.reload();
    },
    toggleMultiLevel() {
      this.multiLevel = !this.multiLevel;
    },
    isNewDownload(download) {
      let obj = this.$store.state.newDownloads.find(
        obj => obj.name == download.name
      );

      return obj != undefined;
    },
    resetNewDownloads() {
      this.$store.commit("clearNewDownloads", []);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    notifyVue(message) {
      // var color = 'info'
      var color = "pz";
      this.$notify({
        message: message,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: color,
        timeout: 10000
      });
    },
    openCart() {
      if (this.$route.params.cartId) {
        this.$router.push({ name: 'SharedCart', params: { id: this.$route.params.cartId, loadCartItems: 0 }})
      } else {
        this.$router.push({ name: 'Cart'})
      }
    }
  }
};
</script>

<style>
.multi-input {
  width: 100%;
  height: 200px;
  margin-bottom: 10px;
  resize: none;
}

.confirmChangeEnvironment > div > div {
  max-width: 25% !important;
}

</style>

<style scoped>
.language-header {
  margin-left: 10px;
  margin-right: 10px;
  padding-left: 5px;
  border-bottom: solid 1px #ccc;
}

.bring-back {
  z-index: initial;
}

.cart-button {
  position: absolute;
  bottom: 10px;
  right: 22px;
}

.cart-button button {
  margin-left: 5px;
}

.user-menu-item a {
  font-size: 12px;
  cursor: pointer;
}

.user-menu-item a span {
  margin-left: 5px;
}

.newDowload {
  font-weight: 500;
}

.topnavbar-pz-link-empty {
  background-color: #fff !important;
}

.topnavbar-pz-link-empty div {
  margin-right: 5px;
  margin-left: 5px;
}

.topnavbar-pz-link-empty span {
  padding-left: 10px;
}

.cancel-change-environment{
  margin-right: 10px;;
}


.confirmChangeEnvironment > div > div {
  max-width: 25% !important;
}


</style>

